export const initialState = {
  open: false,
  product: false,
  simpleProduct: false,
};

export const setProductModal = (store, productModal) => {
  store.setState({ productModal });
};

export const openProductModal = (store, product, formik) => {
  store.setState({
    productModal: {
      open: true,
      product,
      formik,
    },
  });
};

export const closeProductModal = (store) => {
  store.setState({
    productModal: {
      ...store.state.productModal,
      open: false,
    },
  });
};
